import { useRecoilValue } from "recoil";
import {
  empMonthCardIdState,
  holidayDatesState,
} from "../../utils/atoms/atoms";
import { useQuery } from "@tanstack/react-query";
import { getAttdPastMonthById } from "../../api/attendance";
import CustomTable from "../common/CustomTable";
import { AttendanceMonthColumns } from "../../utils/table/attendanceCols";
import { getAttendanceDay, isAttendanceSunday } from "../../utils/funcs/time";
import { parseHolidayDays } from "../../utils/funcs/holidays";

const SalaryMonthCardModal = ({ employeeId }: { employeeId?: number } = {}) => {
  const selectedEmpId = useRecoilValue(empMonthCardIdState);
  const empId = employeeId ?? selectedEmpId;
  const holidayDates = useRecoilValue(holidayDatesState);
  const holidayDays = new Set(parseHolidayDays(holidayDates));
  const {
    isLoading,
    data: attd_past_month_id,
    isSuccess,
    refetch,
  } = useQuery({
    queryKey: ["attd_past_month_id", empId],
    queryFn: () => getAttdPastMonthById(empId),
  });

  return (
    <div className="">
      {isLoading ? (
        "Loading"
      ) : isSuccess ? (
        <CustomTable
          data={attd_past_month_id?.attendance}
          columns={AttendanceMonthColumns}
          rowClassName={(row) => {
            const day = getAttendanceDay(row.curr_date);
            if (day !== null && holidayDays.has(day)) {
              return "attendance-row--holiday";
            }
            return isAttendanceSunday(row.curr_date)
              ? "attendance-row--sunday"
              : "";
          }}
        />
      ) : (
        <div role="alert">
          Could not load attendance.{" "}
          <button
            type="button"
            className="styled-btn--std"
            onClick={() => refetch()}
          >
            Retry
          </button>
        </div>
      )}
    </div>
  );
};

export default SalaryMonthCardModal;
